import React from 'react';
import { injectIntl } from 'react-intl';
import { Checkbox, Popup } from 'semantic-ui-react';
import EditIcon from '../../../../assets/add-ons/edit.svg';
import AddOnListToolTip from '../../../tooltip/addOnListToolTip';
import styles from '../styles-module.css';
import { locale } from './../locale';
import { ACTIVE } from '../../consts';

const AddOnRow = injectIntl(({
  intl,
  addOn,
  rate,
  index,
  hasPermissionForManageAddOns,
  history,
  isDisabled,
  isAllSoldOut,
  onAddOnsDelete,
  onAddOnsStatusChange,
  formatPrices,
  formatAvailable,
}) => {
  const deleteButton = (
    <button
      className="ui fluid icon button"
      onClick={() => onAddOnsDelete(index)}
      disabled={isDisabled}
    >
      <i aria-hidden="true" className="grey large icon universe-delete"/>
    </button>
  );

  const renderActions = () => {
    return (
      <div className={`${styles.column} ${styles.actions}`}>
        <div className={styles.editIcon}>
          <button
            className="ui fluid icon button"
            onClick={() => history.push(`/dashboard/add-ons/edit/${addOn.id}`)}
          >
            <EditIcon />
          </button>
        </div>
        <div className={styles.trashDeleteIcon}>
          {isDisabled
            ? <Popup
                content={intl.formatMessage(locale.cannotDeleteSoldAddOn)}
                trigger={<span role="button" aria-disabled="true" tabIndex={0}>{deleteButton}</span>}
                on={['hover', 'focus']}
                position="top right"
                inverted
                basic
              />
            : deleteButton}
        </div>
      </div>
    );
  }

  const firstRate = rate?.[0];
  const imageUrl = firstRate?.imageUrl;
  const imageContainer = imageUrl &&
    <div className={styles.column}>
      {/* Decorative: the add-on name is rendered adjacent, so alt text here would only duplicate it. */}
      <img src={imageUrl} className={styles.addOnImage} alt="" />
    </div>;
  const addOnColumnClasses = `${styles.column} ${styles.addOn} ${imageUrl && styles.withImage}`;
  const selectedTicketTypesIndicator = () => {
    const selectedCustomisation = addOn?.addOnCustomizations.some(value => value.capacityLimit === null);
    return (
      <div>
        { selectedCustomisation
          ? intl.formatMessage(locale.specificTicketTypesSelectedIndicators)
          : intl.formatMessage(locale.allTicketTypesSelectedIndicators)
        }
      </div>);
  }

  const selectedTimeslotIndicator = () => {
    return (
      <div>
        { addOn?.addOnAvailabilityRules.length > 0
          ? intl.formatMessage(locale.specificTimeslot)
          : intl.formatMessage(locale.allTimeslot)
        }
      </div>);
  }

  const renderAddOnOptions = () => {
    if (addOn?.rates?.length > 1) {
      return addOn?.rates?.map(r=> <div className={styles.option} key={r.id}>{r.optionName}</div>);
    }
    return intl.formatMessage(locale.noOptions);
  }

  return (
    <div className={`${styles.desktopAddOnRow}`}>
      <div className={`${styles.column} ${styles.status} ${styles.toggleCell}`}>
        <Checkbox
          disabled={isAllSoldOut}
          toggle
          checked={firstRate?.state === ACTIVE}
          onChange={(_, { checked }) => onAddOnsStatusChange(index, checked)}
        />
      </div>
      <div className={addOnColumnClasses}>
        {imageContainer}
        <div>
          <div className={styles.addOnName}>{addOn.name}</div>
          <div className={styles.sku}>{firstRate?.sku}</div>
        </div>  
      </div>
      <div className={`${styles.column} ${styles.options}`}>
        {renderAddOnOptions()}
      </div>
      <div className={`${styles.column} ${styles.price}`}>{formatPrices()}</div>
      <div className={`${styles.column} ${styles.available}`}>{formatAvailable()}</div>
      <div className={`${styles.column} ${styles.appliesTo}`}>
        {addOn?.events ? <AddOnListToolTip listings={addOn?.events} addOn={addOn} /> : null}
        {selectedTicketTypesIndicator()}
        {selectedTimeslotIndicator()}
      </div>
      {hasPermissionForManageAddOns && renderActions()}
    </div>
  );
});

export default AddOnRow;
